export const stringVariableMentionsInputTags = [
  { id: 1, display: 'add int variable', value: "int"},
  { id: 2, display: 'add string variable', value: "string"},
  { id: 3, display: 'add float variable', value: "float"},
  { id: 4, display: 'add variable', value: "variable"}
];